(() => {
  if (window.previouslyOwnedTabsInitialized) return;
  window.previouslyOwnedTabsInitialized = true;

  const sectionSelector = '[data-previously-owned-section]';
  const wrapperSelector = '.shopify-section';

  function getSectionWrapper(element) {
    return element.closest(wrapperSelector);
  }

  function resetTabs() {
    document.querySelectorAll('[data-previously-owned-tabs]').forEach((tabs) => tabs.remove());
    document.querySelectorAll(`${wrapperSelector}[data-previously-owned-group]`).forEach((wrapper) => {
      wrapper.hidden = false;
      wrapper.removeAttribute('data-previously-owned-group');
      const section = wrapper.querySelector(sectionSelector);
      section?.removeAttribute('role');
      section?.removeAttribute('aria-labelledby');
    });
  }

  function getConsecutiveGroups() {
    const wrappers = Array.from(document.querySelectorAll(sectionSelector))
      .map(getSectionWrapper)
      .filter((wrapper, index, all) => wrapper && all.indexOf(wrapper) === index);
    const groups = [];
    let currentGroup = [];

    wrappers.forEach((wrapper) => {
      if (currentGroup.length && currentGroup[currentGroup.length - 1].nextElementSibling !== wrapper) {
        if (currentGroup.length > 1) groups.push(currentGroup);
        currentGroup = [];
      }
      currentGroup.push(wrapper);
    });

    if (currentGroup.length > 1) groups.push(currentGroup);
    return groups;
  }

  function buildGroup(wrappers, groupIndex) {
    const nav = document.createElement('nav');
    const pageWidth = document.createElement('div');
    const list = document.createElement('div');
    const groupId = `previously-owned-group-${groupIndex}`;

    nav.className = 'ss-owned-tabs';
    nav.dataset.previouslyOwnedTabs = '';
    nav.setAttribute('aria-label', 'AED options');
    pageWidth.className = 'page-width';
    list.className = 'ss-owned-tabs__list';
    list.setAttribute('role', 'tablist');
    list.setAttribute('aria-label', 'AED options');

    const tabs = [];
    wrappers.forEach((wrapper, index) => {
      const section = wrapper.querySelector(sectionSelector);
      const label = section.dataset.tabLabel.trim() || `Option ${index + 1}`;
      const panelId = section.id || `${groupId}-panel-${index}`;
      section.id = panelId;
      wrapper.dataset.previouslyOwnedGroup = groupId;
      section.setAttribute('role', 'tabpanel');
      tabs.push({ label, panel: panelId, wrapper });
    });
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    const viewAllTab = { label: 'View all', panel: 'all' };
    if (isMobile) {
      tabs.unshift(viewAllTab);
    } else {
      tabs.push(viewAllTab);
    }
    const initialTabIndex = 0;

    const selectTab = (selectedIndex, focusTab = false) => {
      const buttons = Array.from(list.querySelectorAll('[role="tab"]'));
      buttons.forEach((button, index) => {
        const selected = index === selectedIndex;
        button.setAttribute('aria-selected', String(selected));
        button.tabIndex = selected ? 0 : -1;
        if (selected && focusTab) button.focus();
      });

      const selectedTab = tabs[selectedIndex];
      wrappers.forEach((wrapper) => {
        wrapper.hidden = selectedTab.panel !== 'all' && selectedTab.wrapper !== wrapper;
      });
    };

    tabs.forEach((tab, index) => {
      const button = document.createElement('button');
      const tabId = `${groupId}-tab-${index}`;
      button.className = 'ss-owned-tabs__button';
      button.type = 'button';
      button.id = tabId;
      button.textContent = tab.label;
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-selected', String(index === initialTabIndex));
      if (tab.panel !== 'all') button.setAttribute('aria-controls', tab.panel);
      button.tabIndex = index === initialTabIndex ? 0 : -1;
      button.addEventListener('click', () => selectTab(index));
      button.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let nextIndex = index;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        selectTab(nextIndex, true);
      });
      list.appendChild(button);

      if (tab.wrapper) tab.wrapper.querySelector(sectionSelector).setAttribute('aria-labelledby', tabId);
    });

    selectTab(initialTabIndex);

    pageWidth.appendChild(list);
    nav.appendChild(pageWidth);
    wrappers[0].before(nav);
  }

  function initializeTabs() {
    resetTabs();
    getConsecutiveGroups().forEach(buildGroup);
  }

  let refreshTimer;
  const scheduleRefresh = () => {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(initializeTabs, 50);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeTabs, { once: true });
  } else {
    initializeTabs();
  }

  document.addEventListener('shopify:section:load', scheduleRefresh);
  document.addEventListener('shopify:section:unload', scheduleRefresh);
  document.addEventListener('shopify:section:reorder', scheduleRefresh);
  document.addEventListener('shopify:section:select', (event) => {
    const wrapper = event.target.closest(`${wrapperSelector}[data-previously-owned-group]`);
    if (!wrapper || !wrapper.hidden) return;
    const groupId = wrapper.dataset.previouslyOwnedGroup;
    const groupWrappers = Array.from(document.querySelectorAll(
      `${wrapperSelector}[data-previously-owned-group="${groupId}"]`
    ));
    const nav = groupWrappers[0]?.previousElementSibling;
    const panelId = wrapper.querySelector(sectionSelector)?.id;
    Array.from(nav?.querySelectorAll('[role="tab"]') || [])
      .find((button) => button.getAttribute('aria-controls') === panelId)
      ?.click();
  });
})();
